import { Component, OnInit } from '@angular/core';
import { UserActivityServiceService } from '../../../../services/raintree/Transmission/user-activity-service.service';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { merge } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivityFilterComponent } from './activity-filter/activity-filter.component';
import test from 'node:test';

enum ReportTypes {
  GLOBAL = 'ALL',
  COUNTRIES = 'COUNTRIES',
  STATES = 'STATES',
  DISTRICTS = 'DISTRICTS',
}

@Component({
  selector: 'app-user-activity-report',
  standalone: true,
  imports: [LoaderComponent],
  templateUrl: './user-activity-report.component.html',
  styleUrl: './user-activity-report.component.scss'
})


export class UserActivityReportComponent implements OnInit {

  userReport: any;
  isLoading: boolean = false;
  showReportType: string = '';
  roleTypes: any[] = [];
  selectedState: any;
  selectedDistrict: any;
  selectedCountry: any;
  isMobile: boolean = false;
  isRoleExist: boolean = false;
  filterPayload: any = {};
  userStatus: string = '';
  showUsers: boolean = false

  constructor(
    private userService: UserActivityServiceService,
    private toaster: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.isMobile = window.matchMedia("(max-width: 600px)").matches
    this.subscribeToRoute()
    this.getRoleTypes()
  }

  getRoleTypes() {
    this.userService.fetchRoletypes().subscribe({
      next: (res) => {
        this.roleTypes = res.data
      }
    })
  }

  getActivityReport(queryParams: any) {
    this.isLoading = true
    this.userService.fetchActivityReport(queryParams).subscribe({
      next: (res) => {
        this.isLoading = false
        if (res.data.length > 0) {
          this.userReport = res.data
        } else {
          this.userReport = [res.data]
        }
      },
      error: (err) => {
        this.isLoading = false
        this.toaster.error(err)
      }
    })

  }

  subscribeToRoute() {
    this.activatedRoute.queryParams.subscribe(param => {
      if (param['country'] && !param['state']) {
        this.showReportType = ReportTypes.COUNTRIES
        this.selectedCountry = param['country']
        !this.isRoleExist ? this.getActivityReport({ cumulative: false }) : this.getActivityReport({ cumulative: false, roleTypes: this.filterPayload.roleTypes });

      } else if (param['country'] && param['state'] && !param['district'] && param['state'] !== 'ALL') {
        this.showReportType = ReportTypes.STATES
        this.selectedState = param['state'];
        !this.isRoleExist ? this.getActivityReport({ cumulative: false, uiState: param['state'] })
          : this.getActivityReport({ cumulative: false, roleTypes: this.filterPayload.roleTypes, uiState: param['state'] });
        // this.getActivityReport({ cumulative: false, uiState: param['state'] });
      } else if (param['country'] && param['state'] && param['district'] && (param['state'] !== 'ALL' || param['district'] !== 'ALL')) {
        this.showReportType = ReportTypes.DISTRICTS
        // this.selectedState = param['state'];
        this.selectedDistrict = param['district']

        // this.getActivityReport({ cumulative: false, uiState: param['state'], uiDistrict: param['district'] });
      } else if (!param['country']) {
        this.showReportType = ReportTypes.GLOBAL
        !this.isRoleExist ? this.getActivityReport({ cumulative: true }) : this.getActivityReport({ cumulative: true, roleTypes: this.filterPayload.roleTypes });
      }
    })
  }

  onCountryClick(item: any) {
    this.showReportType = ReportTypes.COUNTRIES
    this.router.navigate([`${this.router.url}`], {
      queryParams: {
        country: item
      },

    })
  }

  onStateClick(state: any, status?: any) {
    // this.selectedState = state
    let qparams: any;
    this.showReportType = ReportTypes.STATES

    this.activatedRoute.queryParams.subscribe((params) => {
      qparams = Object.assign({}, params);
    });
    qparams.state = state
    this.router.navigate([`${this.router.url.split('?')[0]}`], {
      queryParams: qparams,
    });

    if (state === 'ALL') {
      this.userStatus = status
      this.showUsers = true
      this.showReportType = ReportTypes.DISTRICTS
      this.getActivityReport({ cumulative: false, showUsers: true, userStatus: status });
    }
  }


  onDistrictClick(district: any, status: string) {
    
    // this.selectedDistrict = district
    let qparams: any;
    this.showReportType = ReportTypes.DISTRICTS
    this.activatedRoute.queryParams.subscribe((params) => {
      qparams = Object.assign({}, params);
    });
    qparams.district = district
    this.router.navigate([`${this.router.url.split('?')[0]}`], {
      queryParams: qparams,
    });

    if (district === 'ALL') {
      this.userStatus = status
      this.showUsers = true
      !this.isRoleExist ? this.getActivityReport({ cumulative: false, uiState: this.selectedState, showUsers: true, userStatus: status })
        : this.getActivityReport({ cumulative: false, uiState: this.selectedState, showUsers: true, userStatus: status, roleTypes: this.filterPayload.roleTypes })
    } else {
      !this.isRoleExist ? this.getActivityReport({
        cumulative: false,
        uiState: this.selectedState,
        uiDistrict: district,
        userStatus: status
      }) :
        this.getActivityReport({
          cumulative: false,
          uiState: this.selectedState,
          uiDistrict: district,
          userStatus: status,
          roleTypes: this.filterPayload.roleTypes
        })
    }
  }

  onFilterClick() {
    const dialogRef = this.dialog.open(ActivityFilterComponent, {
      data: {
        roles: this.roleTypes,
        country: this.selectedCountry,
        state: this.selectedState ?? '',
        district: this.selectedDistrict ?? '',
        selectedRoles: this.filterPayload.roleTypes,
        selectedUserName: this.filterPayload.userName,
        selectedEmail: this.filterPayload.email
      }
    })
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        this.isRoleExist = res.roleTypes?.length > 0
        if (res ) {
          let payload = {
            cumulative: this.selectedCountry ? false : true,
            uiState: this.selectedState !== 'ALL' ? res.state : '',
            uiDistrict: this.selectedDistrict !== 'ALL' ? res.district : '',
            userName: res.userName,
            email: res.email,
            showUsers: this.showUsers ? true : '',
            userStatus: this.userStatus ?? '' ,
            roleTypes: res.roleTypes.length > 0 ? res.roleTypes : ''
          }
          this.filterPayload = Object.fromEntries(
            Object.entries(payload).filter(
              ([Key, value]) => {
                return (
                  value !== null &&
                  value !== undefined &&
                  value !== ''
                );
              }
            )
          );
          this.getActivityReport(this.filterPayload)
        }
      }
    })
  }

}
